'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdDeleteForever = function MdDeleteForever(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25.9 6.6h5.7v3.4h-23.2v-3.4h5.7l1.8-1.6h8.2z m-11.8 13.2l3.6 3.6-3.6 3.5 2.4 2.3 3.5-3.5 3.5 3.5 2.4-2.3-3.6-3.5 3.6-3.6-2.4-2.4-3.5 3.6-3.5-3.6z m-4.1 11.8v-20h20v20c0 1.8-1.6 3.4-3.4 3.4h-13.2c-1.8 0-3.4-1.6-3.4-3.4z' })
        )
    );
};

exports.default = MdDeleteForever;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/delete-forever.js
// module id = 2776
// module chunks = 0